import { CASH_RECEIPT_TRANSACTION_REQUEST, GET_CASH_RECEIPT_TRANSACTIONS, CASH_RECEIPT_TRANSACTION_REQUEST_FAILURE } from '../types';

const initialState = {
  cashReceiptTransactions: [],
  loading: false,
  error: null,
};

const cashReceiptTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CASH_RECEIPT_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_CASH_RECEIPT_TRANSACTIONS: {
      return {
        ...state,
        cashReceiptTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CASH_RECEIPT_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default cashReceiptTransactionReducer;